window._active_menu = window._active_menu || '';

$(document).ready(function(){

    $('.main-sidebar .nav .nav-link.ajax').click(function(){
        window._active_menu = $(this).attr('menu');
        update();
    });

    $('.clear-menu').click(function(){
        window._active_menu = '';
        update();
    });

    init();

});

export function init(){

    let parts = window._active_menu.split('.');
    if(parts.length > 1){
        $('.main-sidebar .nav > .nav-item > .nav-link[menu="' + parts[0] + '"]').closest('.nav-item').addClass('menu-is-opening menu-open');
    }

    update();

}

export function update(){

    let parts = window._active_menu.split('.');

    $('.main-sidebar .nav > .nav-item > .nav-link').removeClass('active');
    $('.main-sidebar .nav > .nav-item > .nav-link[menu="' + parts[0] + '"]').addClass('active');

    if(parts.length > 1){
        $('.main-sidebar .nav > .nav-item > .nav-link[menu="' + parts[0] + '"] + .nav > .nav-item > .nav-link[menu="' + (parts[0] + '.' + parts[1]) + '"]').addClass('active');
    }

}

export function select(menu){

    window._active_menu = menu;
    update();

}